import ReferAFriend from "./ReferAFriend"

export default ReferAFriend
